import { AVATAR_PROPERTIES } from '@/utils/CONST';
import { useMemo } from 'react';
import { useGetList } from 'react-admin';

interface Output {
    isLoading: boolean;
    properties: {
        name: string;
        value: string;
        id: string;
        avatar: string;
        customFields: any;
    }[];
    refetch: any;
}

interface Params {
    avatarId: string | string[] | undefined;
    enabled?: boolean;
    propertiesNames?: string[];
    filters?: any;
    queryKey?: string;
}

const useGetAvatarProperties = ({
    avatarId = '',
    enabled = true,
    propertiesNames,
    filters = {},
    queryKey = AVATAR_PROPERTIES,
}: Params): Output => {
    const { data, isLoading, refetch }: any = useGetList(
        queryKey,
        {
            filter: {
                'avatar.id': avatarId,
                ...(propertiesNames && {
                    name: propertiesNames,
                }),
                ...filters,
            },
            meta: {
                realResource: AVATAR_PROPERTIES,
            },
        },
        {
            enabled: enabled && avatarId !== '' && avatarId !== null && avatarId !== undefined,
        },
    );

    const properties = useMemo(() => (data && data.length > 0 ? data : []), [data]);

    return {
        properties,
        isLoading,
        refetch,
    };
};

export default useGetAvatarProperties;
